export const NoticiasActionTypes = {
  API_RESPONSE_SUCCESS: '@@noticias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@noticias/API_RESPONSE_ERROR',

  GET_NOTICIA: '@@noticias/GET_NOTICIA',
  LIST_NOTICIAS: '@@noticias/LIST_NOTICIAS',
  ADD_NOTICIA: '@@noticias/ADD_NOTICIA',
  UPDATE_NOTICIA: '@@noticias/UPDATE_NOTICIA',
  DELETE_NOTICIA: '@@noticias/DELETE_NOTICIA',
  SET_FILTER: '@@noticias/SET_FILTER',

  RESET: '@@noticias/RESET'
}
